import { FORCE_ACTIONS } from '../actions';
import { ForceState } from '../state';

export const updateForcesBatchTimestampsReducer = (
    state: ForceState,
    { forces }: ReturnType<typeof FORCE_ACTIONS.UPDATE_FORCES_BATCH_TIMESTAMPS>
) => {
    // Create a map of timestamp updates for O(1) lookup
    const updateMap = new Map(forces.map((f) => [f.id, f.updatedAt]));

    const updatedForces = state.forces.map((f) => {
        const newTimestamp = updateMap.get(f.id);
        if (newTimestamp === undefined) {
            return f;
        }

        // Only update the timestamp, preserving all other force data
        return {
            ...f,
            updatedAt: newTimestamp
        };
    });

    const newState = {
        ...state,
        forces: updatedForces
    };

    return newState;
};
